import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';import ProjectsList from '../../components/admincomponents/ProjectsList';
import ProjectsListFeatured from "../../components/admincomponents/ProjectsListFeatured";

function AdminProjectsFeatured({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ProjectsListFeatured />            
    </>
  );
}

export default AdminProjectsFeatured;
